import React, { Component } from "react"
// eslint-disable-line no-unused-vars

import SpotButton from "../spot-button/spot-button"

import Width from "../../shared/utils/js/width"
import NavigationData from "../utils/js/navigation-data-desktop"
import Emitter from "../../helpers/emitter"

import "./_main-navigation.scss"

class MainNavigation extends Component {
  static TYPE = { CATEGORY: "SiteNavigationElement", SPACING: "spacing" }

  static defaultProps = {
    modifier: "",
    text: "Lorem ipsum",
    data: NavigationData,
    onlyTopLevel: false,
    categoryClickHandler: null,
    // searchActive: false
  }

  constructor(props) {
    super(props)

    this.state = {
      activeLevel2Index: null,
      topLevelHover: false,
      subLevelHover: false,
      searchActive: false,
    }

    this.timeoutHandle = null
  }

  componentDidMount() {
    Emitter.on("*", (e) => this.handleEvent(e))
  }

  handleEvent(e) {
    const { type } = e
    switch (type) {
      case "SEARCH_INPUT_ACTIVE_STATE_UPDATE":
        this.setState({ searchActive: e.state })
        break
      default:
        break
    }
  }

  topLevelHoverHandler = (event, index, content) => {
    if (this.props.onlyTopLevel || this.state.searchActive) return

    clearTimeout(this.timeoutHandle)

    this.timeoutHandle = setTimeout(() => {
      if (content.length > 0) this.setState({ topLevelHover: true, activeLevel2Index: index })
      else this.setState({ topLevelHover: false, activeLevel2Index: null })
    }, 200)
  }

  topLevelClickHandler = (event, index) => {
    if (this.props.categoryClickHandler) {
      this.props.categoryClickHandler(event, index)
    }
  }

  topLevelUnhoverHandler = (event, index) => {
    if (this.props.onlyTopLevel || this.state.searchActive) return

    clearTimeout(this.timeoutHandle)

    this.timeoutHandle = setTimeout(() => {
      this.setState({ topLevelHover: false })
      if (!this.state.subLevelHover) this.setState({ activeLevel2Index: null })
    }, 100)
  }

  subLevelHoverHandler = (event) => {
    if (this.props.onlyTopLevel || this.state.searchActive) return

    clearTimeout(this.timeoutHandle)
    this.setState({ subLevelHover: true })
    this.setState({ topLevelHover: false })
  }

  subLevelUnhoverHandler = (event) => {
    if (this.props.onlyTopLevel || this.state.searchActive) return

    this.timeoutHandle = setTimeout(() => {
      this.setState({ subLevelHover: false })
      if (!this.state.topLevelHover) this.setState({ activeLevel2Index: null })
    }, 100)
  }

  render() {
    if (!this.props.data) return null
    return (
      <nav className={`main-navigation ${this.props.modifier} ${this.state.activeLevel2Index ? "is-active" : ""}`}>
        <div className="main-navigation__level1">
          <Width modifier="w--widerplus">
            <div className="main-navigation__level1__list">
              {this.props.data.map((item, index) => {
                return (
                  <MainNavigationTopLevel
                    key={`topLevelItem${index}`}
                    data={item}
                    index={index}
                    onlyTopLevel={this.props.onlyTopLevel}
                    mouseEnterHandler={this.topLevelHoverHandler.bind(this)}
                    mouseLeaveHandler={this.topLevelUnhoverHandler.bind(this)}
                    clickHandler={this.topLevelClickHandler.bind(this)}
                  />
                )
              })}
            </div>
          </Width>
        </div>
        {!this.props.onlyTopLevel && (
          <ul className={`main-navigation__level2 ${this.state.activeLevel2Index ? "is-active" : ""}`}>
            {this.props.data.map((item, index) => {
              if (item.columns) {
                return (
                  <MainNavigationSubLevel
                    key={`subLevelItem${index}`}
                    data={item.columns}
                    itemData={item}
                    index={index}
                    active={this.state.activeLevel2Index === index}
                    mouseEnterHandler={this.subLevelHoverHandler.bind(this)}
                    mouseLeaveHandler={this.subLevelUnhoverHandler.bind(this)}
                  />
                )
              }
              return <span className="main-navigation__level2__item" key={`subLevelItem${index}`}></span>
            })}
          </ul>
        )}
      </nav>
    )
  }
}

class MainNavigationTopLevel extends Component {
  static defaultProps = {
    modifier: "",
    data: null,
    index: 0,
    onlyTopLevel: false,
    mouseEnterHandler: null,
    mouseLeaveHandler: null,
    clickHandler: null,
  }

  constructor(props) {
    super(props)

    this.state = {
      active: false,
    }
  }

  mouseEnterHandler = (event) => {
    if (this.props.mouseEnterHandler) {
      this.props.mouseEnterHandler(event, this.props.index, this.props.data.columns)
    }
  }
  mouseLeaveHandler = (event) => {
    if (this.props.mouseLeaveHandler) {
      this.props.mouseLeaveHandler(event, this.props.index, this.props.data.columns)
    }
  }
  clickHandler = (event) => {
    if (this.props.clickHandler) {
      this.props.clickHandler(event, this.props.index)
    }
  }

  render() {
    if (this.props.data.link && this.props.data.link.url) {
      return (
        <div
          className="main-navigation__level1__item"
          onMouseEnter={this.mouseEnterHandler.bind(this)}
          onMouseLeave={this.mouseLeaveHandler.bind(this)}
        >
          <a
            href={this.props.data.link.url}
            className={`${this.props.data.highlight ? "is-highlighted" : ""}${this.state.active ? "is-active" : ""}`}
            onClick={this.clickHandler.bind(this)}
          >
            <span>
              {this.props.data.link.name} <em>›</em>
            </span>
          </a>
        </div>
      )
    } else {
      return null
    }
  }
}

class MainNavigationSubLevel extends Component {
  static defaultProps = {
    modifier: "",
    data: null,
    index: 0,
    active: false,
    mouseEnterHandler: null,
    mouseLeaveHandler: null,
    itemData: null,
  }

  mouseEnterHandler = (event) => {
    if (this.props.mouseEnterHandler) {
      this.props.mouseEnterHandler(event)
    }
  }
  mouseLeaveHandler = (event) => {
    if (this.props.mouseLeaveHandler) {
      this.props.mouseLeaveHandler(event)
    }
  }

  render() {
    return (
      <li
        className={`main-navigation__level2__item ${this.props.active ? "is-active" : ""}`}
        onMouseEnter={this.mouseEnterHandler.bind(this)}
        onMouseLeave={this.mouseLeaveHandler.bind(this)}
      >
        {this.props.data && (
          <div className="main-navigation__level2__item__inner">
            <div className="main-navigation__links">
              {this.props.data.map((col, index1) => {
                return (
                  <div key={`subLevelItem${this.props.index}Col${index1}`} className="col">
                    {col.map((item, index2) => {
                      return (
                        <div key={`subLevelItem${this.props.index}Col${index1}Item${index2}`}>
                          {!item.spacing && (
                            <a href={item.link.url} className={`category ${item.highlight ? "is-highlighted" : ""}`}>
                              <span>{item.link.name}</span>
                            </a>
                          )}

                          {item.subLinks &&
                            item.subLinks.length > 0 &&
                            item.subLinks.map((link, index3) => {
                              return (
                                <a key={`subLevelItem${this.props.index}Col${index1}Item${index2}Link${index3}`} href={link.url}>
                                  <span>
                                    <em>{link.name}</em>
                                  </span>
                                </a>
                              )
                            })}

                          {item.spacing && <hr />}
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </div>
            {this.props.itemData && (
              <div className="main-navigation__level2__item__spot">
                <SpotButton
                  Title={this.props.itemData.spotColumnLink.name}
                  Description={this.props.itemData.spotColumnLinkText}
                  LinkTarget={this.props.itemData.spotColumnLink.target}
                  LinkUrl={this.props.itemData.spotColumnLink.url}
                  ImageAltText={this.props.itemData.spotColumnImageAltText}
                  ImageUrl={this.props.itemData.spotColumnImageUrl}
                  imageUrlMobile={this.props.itemData.spotColumnImageUrl}
                />
              </div>
            )}
          </div>
        )}
      </li>
    )
  }
}

export default MainNavigation
